import { setSpecificMessage, mac48 } from "valibot";
setSpecificMessage(
  mac48,
  (issue) => `MAC 48-bit invalide: reçu ${issue.received}`,
  "fr"
);